import { Injectable } from '@angular/core';

import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { IAccount, MarketplacePermission } from './authentication.interface';
import { AuthenticationService } from './authentication.service';
import { CLAIMS } from '../claims';

export class LocationManagerExperienceConfig {
  isLocationManager: boolean = false;
  isInBeta: boolean = false;
}

@Injectable({
  providedIn: 'root',
})
export class LocationManagerExperienceService {
  constructor(private auth: AuthenticationService) {}

  getExperience(): Observable<LocationManagerExperienceConfig> {
    return combineLatest([
      this.createAccountObs(),
      this.createPermissionObs(),
    ]).pipe(
      map(([account]) => {
        const isLocationManager: boolean =
          !this.auth.isImpersonatedUser() &&
          this.auth.hasClaims([CLAIMS.locationManager]);

        const config = new LocationManagerExperienceConfig();
        config.isLocationManager = isLocationManager;
        return config;
      }),
    );
  }

  private createAccountObs(): Observable<IAccount> {
    return this.auth.account$.pipe(
      // filter out the "default" that is an empty instance
      filter((a: IAccount) => !!a.id),
    );
  }

  private createPermissionObs(): Observable<MarketplacePermission> {
    return this.auth.permission$.pipe(
      // filter out the "default" that is an empty instance
      filter((p: MarketplacePermission) => !!p.claims.length),
    );
  }
}
